export const AUTOCOMPLETE_FIELDS = ['geometry', 'address_components', 'types', 'name', 'url']

/**
 * 詳細な住所であるか、曖昧な可能性がある場合施設や駅などが指定されているかを判定
 * @param place
 * @returns
 */
export function isValidPlace(place: google.maps.places.PlaceResult) {
  if (!place.geometry?.location || !place.address_components || !place.types) {
    return false
  }

  let isDetailedPlace = false
  let needCheckWithPlaceType = false

  // 住所情報のタイプから詳細、またはやや曖昧な住所かを判定
  for (const address of place.address_components) {
    for (const type of address.types) {
      if (!isDetailedPlace) {
        if (type === 'premise' || type === 'street_number' || type === 'sublocality_level_4') {
          isDetailedPlace = true
        } else if (type === 'sublocality_level_2' || type === 'sublocality_level_3') {
          needCheckWithPlaceType = true
        }
      }
    }
  }

  if (!isDetailedPlace && !needCheckWithPlaceType) {
    return false
  }

  if (isDetailedPlace) {
    return true
  }

  // 駅または施設、ホテル、観光地などの詳細な場所かを判定
  const detailedPlaceType = place.types?.find(
    type =>
      type === 'train_station' ||
      type === 'transit_station' ||
      type === 'establishment' ||
      type === 'lodging' ||
      type === 'point_of_interest'
  )

  return Boolean(detailedPlaceType)
}
